<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { LocalStorage } from 'shared/helpers/localStorage';
import {
  browserNotificationsSupported,
  enableNotifications,
  needsHomeScreenForNotifications,
  showTestNotification,
} from 'dashboard/helper/AudioAlerts/browserNotification';
import Button from 'dashboard/components-next/button/Button.vue';

// Convite para notificacoes do navegador. Quem nao ativar fica so com o som.
const DISMISSED_KEY = 'redhosting_browser_notifications_dismissed';

const { t } = useI18n();

// "default": ainda nao perguntou; "denied": bloqueado, mostra como liberar;
// "homescreen": iPhone no Safari, que so notifica com o site na Tela de Inicio.
const initialPermission = () => {
  if (needsHomeScreenForNotifications()) return 'homescreen';
  return browserNotificationsSupported()
    ? Notification.permission
    : 'unsupported';
};
const permission = ref(initialPermission());
const isVisible = ref(
  ['default', 'denied', 'homescreen'].includes(permission.value) &&
    !LocalStorage.get(DISMISSED_KEY)
);

const TEXTS = {
  default: ['TITLE', 'DESCRIPTION'],
  denied: ['BLOCKED_TITLE', 'BLOCKED_DESCRIPTION'],
  homescreen: ['HOMESCREEN_TITLE', 'HOMESCREEN_DESCRIPTION'],
};
const text = index =>
  t(`SIDEBAR.BROWSER_NOTIFICATIONS.${TEXTS[permission.value][index]}`);

const enable = async () => {
  permission.value = await enableNotifications();
  if (permission.value === 'granted') {
    showTestNotification(
      t('SIDEBAR.BROWSER_NOTIFICATIONS.TEST_TITLE'),
      t('SIDEBAR.BROWSER_NOTIFICATIONS.TEST_BODY')
    );
    isVisible.value = false;
  }
};

const dismiss = () => {
  LocalStorage.set(DISMISSED_KEY, true);
  isVisible.value = false;
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div
    v-if="isVisible"
    class="flex flex-col gap-2 p-3 mx-2 mb-3 rounded-xl bg-n-alpha-1 outline outline-1 -outline-offset-1 outline-n-weak"
  >
    <div class="flex items-center gap-2 text-sm font-medium text-n-slate-12">
      <span class="flex-shrink-0 i-lucide-bell-ring size-4 text-n-brand" />
      {{ text(0) }}
    </div>
    <p class="m-0 text-xs text-n-slate-11">
      {{ text(1) }}
    </p>
    <div class="flex gap-2">
      <Button
        v-if="permission === 'default'"
        :label="t('SIDEBAR.BROWSER_NOTIFICATIONS.ENABLE')"
        xs
        @click="enable"
      />
      <Button
        :label="t('SIDEBAR.BROWSER_NOTIFICATIONS.DISMISS')"
        xs
        slate
        faded
        @click="dismiss"
      />
    </div>
  </div>
</template>
